<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-28                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <product-category-assignment v-for="category_assignment in category_assignments" :key="category_assignment.id"
                                 :category-assignment="category_assignment"
                               :is-public="isPublic" >
    </product-category-assignment>
    <b-container v-if="subcategories.length > 0">
      <b-row >
        <b-col>
          <small>Didn't find what you are looking for? <b-button variant="link" size="sm" v-on:click="selectCategory(subcategories[0].id)">Click to Configure</b-button>
          </small>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ProductCategoryProducts from "@/components/dynabook_shared/product-category-products.vue";
import ProductCategorySubcategoryCards from "@/components/dynabook_shared/product-category-subcategory-cards.vue";
import ProductCategoryAssignment from "@/components/dynabook_shared/product-category-assignment.vue";

export default {
  name: "product-category-non-bto-and-bto-list",
  components: {ProductCategoryAssignment, ProductCategorySubcategoryCards, ProductCategoryProducts},
  props: {
    category: {
      type: Object,
      required: true
    },
    subcategories:{
      type: Array,
      required: true
    },
    category_assignments: {
      type: Array,
      required: true
    },
    isPublic: {
      type: Boolean,
      required: true
    }
  },
  methods:{
    selectCategory(category_id){
      this.$emit('category-selected',category_id);
    }
  }
}
</script>

<style scoped>

</style>
